export class FrontDesk {
  first_name: string;
  last_name: string;
  contact_no: number;
  email_id: string;
  password: string;
  role_name: number;
  dob: string;
  ocode: string;
  address_1: string;
  address_2: string;
  city: string;
  state: string;
  zip: number;
  additional_info: string;
  u_id: Number;
  ppurl: any;
  name: string;
  avatarimg: any;
}
